import { Typography } from "@material-ui/core"

export const ThermalCyclingView = ({ procedureData }: { procedureData: any }) => {
  return (
    <div>
      <Typography variant="body1">
        Test duration :{procedureData?.thermal_cycling?.test_duration ? `${procedureData?.thermal_cycling.test_duration} hours` : "N/A"}
      </Typography>
      <Typography variant="body1">
        Test condition : {procedureData?.thermal_cycling?.test_condition ? `${procedureData.thermal_cycling.test_condition} °C` : "N/A"}
      </Typography>
      <Typography variant="body1">
        Equipment Calibration Date :{procedureData?.thermal_cycling?.equipment_calibration_date ? procedureData.thermal_cycling.equipment_calibration_date.substring(0, 10) : "N/A"}
      </Typography>
      <Typography variant="body1">
        Number of Cycles : {procedureData?.thermal_cycling?.number_of_cycles ? procedureData.thermal_cycling.number_of_cycles : "N/A"}
      </Typography>
      {/* <Typography variant="body1">
        Applied Current Low : {procedureData?.thermal_cycling?.applied_current_low ?`${procedureData.thermal_cycling.applied_current_low} A`  : "N/A"} 
      </Typography> */}

      {(procedureData?.tsd_version === "v12" &&
        <Typography variant="body1">
          Weight : {procedureData?.thermal_cycling?.weight ? `${procedureData.thermal_cycling.weight}  g` : "N/A"}
        </Typography>
      )}

      <Typography variant="body1">
        Current voltage normal : {procedureData?.thermal_cycling?.current_voltage_normal ? procedureData.thermal_cycling.current_voltage_normal : "N/A"}
      </Typography>

    </div>
  )
}